import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { Card, Checkbox, Colors } from 'react-native-paper';
import { FontAwesome5 } from '@expo/vector-icons';

import { pixelDimensions } from '../../config/utils';
import { AppButton, AppText } from '../form';
import { appColors } from '../../assets/styles/global';

const CardPersonalTrainer = ({
  onPress, personalName, cref, exp, noButton = false, profilePic, isAll, data = {
    acceptAgreement: false,
    setAcceptAgreement: () => {},
    handleButtonAgreement: () => {},
  },
}) => (
  <View style={styles.baseView}>
    <Card style={styles.card}>
      <View style={styles.contentCard}>
        <View style={styles.viewAvatar}>
          {profilePic
            ? <Image source={{ uri: profilePic }} style={styles.imageChangePic} />
            : <FontAwesome5 name="user-circle" size={pixelDimensions(13)} />}
        </View>
        <View style={styles.viewInfo}>
          <AppText style={styles.textTitle}>{personalName}</AppText>
          <AppText numberOfLines={2} style={styles.textSubTitle}>{exp !== null && (exp)}</AppText>
          {!noButton && (
          <AppButton
            mode="contained"
            onPress={onPress}
            style={styles.buttonSelect}
            labelStyle={styles.textButtonSelect}
            label="Selecionar"
          />
          )}
          {isAll && (
            <>
              <View style={styles.viewAcceptAgreement}>
                <AppButton size="bold" labelStyle={styles.textAgreement} style={styles.buttonAgreement} onPress={data.handleButtonAgreement} label="Termos de Uso" />

                <Checkbox
                  status={data.acceptAgreement ? 'checked' : 'unchecked'}
                  onPress={() => {
                    data.setAcceptAgreement(!data.acceptAgreement);
                  }}
                />
                <AppText>Aceitar Termos</AppText>
              </View>
            </>
          )}
        </View>
      </View>
    </Card>
  </View>
);

const styles = StyleSheet.create({
  card: {
    borderRadius: pixelDimensions(3),
    margin: pixelDimensions(2),
  },
  contentCard: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  viewAvatar: {
    paddingHorizontal: pixelDimensions(3),
  },
  viewInfo: {
    flex: 1,
    paddingHorizontal: pixelDimensions(3),
  },
  buttonSelect: {
    alignSelf: 'flex-end',
    padding: pixelDimensions(2),
    marginBottom: pixelDimensions(1.5),
  },
  textSubTitle: {
    fontSize: pixelDimensions(4),
    maxWidth: pixelDimensions(65),
    marginBottom: pixelDimensions(3),
  },
  textButtonSelect: {
    color: appColors.white,
  },
  textTitle: {
    fontFamily: 'MBold',
    fontSize: pixelDimensions(4.5),
    marginTop: pixelDimensions(3),
  },
  imageChangePic: {
    backgroundColor: 'white',
    width: pixelDimensions(15),
    height: pixelDimensions(15),
    resizeMode: 'contain',

  },
  viewAcceptAgreement: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: pixelDimensions(3),
  },
  buttonAgreement: {
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(4),
  },
  textAgreement: {
    color: Colors.white,
    fontSize: pixelDimensions(3.5),
  },
});

export default CardPersonalTrainer;
